import React from 'react';
import '../CSS/contact.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from '@material-ui/core';



class ContactInfo extends React.Component{
    render(){
        return(
            <div>
                 <Container>
                <Row>
                   
                        <Col md={12}>
                            <div className="infoContacts">
                                Send us your inquiries<br/>
                                we'll respond right away.

                            </div>
                        </Col>
                    
                </Row>
                </Container>

            </div>
        )
    }

}



export default ContactInfo;
